import { createAsyncThunk } from "@reduxjs/toolkit";
import { triggerAlert } from "redux/reducers/appSlice";
import { reservationChangeSchedulePayload } from "services/service-models";
import studentServices from "services/students";
import { translateAPIMessage } from "utils/translation";

export const studentLessonsFilter = createAsyncThunk(
  "get/studentLessons",
  async (data: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await studentServices.studentLessonsFilter(data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getMyLessons = createAsyncThunk(
  "get/getMyLessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await studentServices.getMyLessons();
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const cancelStudentLessonReservation = createAsyncThunk(
  "cancel/Student/Lesson/Reservation",
  async (reservation_id: number, { rejectWithValue, dispatch }) => {
    try {
      await studentServices.cancelStudentLessonReservation(reservation_id);
      dispatch(getMyLessons());
      return true;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(error.response.data.message as number),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const refundStudentLessonReservation = createAsyncThunk(
  "refund/Student/Lesson/Reservation",
  async (reservation_id: number, { rejectWithValue, dispatch }) => {
    try {
      await studentServices.refundStudentLessonReservation(reservation_id);
      dispatch(getMyLessons());
      return true;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(error.response.data.message as number),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const changeStudentLessonReservation = createAsyncThunk(
  "change/Student/Lesson/Reservation",
  async (
    data: reservationChangeSchedulePayload,
    { rejectWithValue, dispatch }
  ) => {
    try {
      await studentServices.changeStudentLessonReservation(data);
      dispatch(getMyLessons());
      return true;
    } catch (error: any) {
      dispatch(
        triggerAlert({
          type: "error",
          children: translateAPIMessage(error.response.data.message as number),
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const getIndividualReservedLessons = createAsyncThunk(
  "get/getIndividualReservedLessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await studentServices.fetchReservedLessons();
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const getIndividualNotUsedLessons = createAsyncThunk(
  "get/getIndividualNotUsedLessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await studentServices.fetchNotUsedLessons();
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
export const getIndividualCompletedLessons = createAsyncThunk(
  "get/getIndividualCompletedLessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await studentServices.fetchCompletedLessons();
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupLessons = createAsyncThunk(
  "get/groupLessons",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await studentServices.fetchGroupLessons();
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const notifyNoAvailableReservations = createAsyncThunk(
  "/reservation/noAvailableDates",
  async (data: { lesson_id: string }, { rejectWithValue, dispatch }) => {
    try {
      const res = await studentServices.notifyNoAvailableReservations(data);
      return res;
    } catch (error: any) {
      dispatch(triggerAlert({ type: "error", children: "Failed to send notification." }));
      return rejectWithValue(error);
    }
  }
);
